import { FC } from 'react';
import {
  InsuranceInactiveStatus,
  InsuranceVerifiedStatus,
  ManuallyVerifiedStatus,
  SelfPayStatus,
  VerificationInProcessStatus
} from '../../shared/styles';
import { ApptRequestIvStatusButtonProps, ApptRequestIvStatusButton as Button } from './status-button';

export const ApptRequestIvStatusButtonSelector: FC<Partial<ApptRequestIvStatusButtonProps>> = (props) => {
  const { ivSummary } = props;

  switch (ivSummary?.ivSummaryStatus) {
    case 'InsuranceInProcess':
      return <Button text="Verification in Process" icon={<VerificationInProcessStatus />} {...props} />;
    case 'InsuranceVerified':
      return <Button text="Insurance Verified" icon={<InsuranceVerifiedStatus />} {...props} />;
    case 'SelfPay':
      return <Button text="Self Pay" icon={<SelfPayStatus />} {...props} />;
    case 'ManuallyVerified':
      return <Button text="Manually Verified" icon={<ManuallyVerifiedStatus />} {...props} />;
    case 'InsuranceInactive':
      return <Button text="Insurance Inactive" icon={<InsuranceInactiveStatus />} {...props} />;
    case 'InsuranceTermed':
      return <Button text="Insurance Termed" icon={<InsuranceInactiveStatus />} {...props} />;
    case 'PatientDataMissing':
      return <Button text="Data Missing" icon={<InsuranceInactiveStatus />} {...props} />;
    case 'RequestDataInvalid':
      return <Button text="Data Invalid" icon={<InsuranceInactiveStatus />} {...props} />;
    case 'PayerNotSetup':
      return <Button text="Payer Not Setup" icon={<InsuranceInactiveStatus />} {...props} />;
    case 'NpiInvalid':
    case 'NpiMissing':
    case 'ProviderRelationshipInvalid':
    case 'NotRegisteredWithPayer':
    case 'PayerUnableToRespond':
    case 'InaccurateData':
    case 'UnknownPatient':
      return <Button text="Needs Attention" icon={<InsuranceInactiveStatus />} {...props} />;
    default: {
      console.log('Unknown insurance verification status:', props.ivSummary?.ivSummaryStatus);

      return null;
    }
  }
};
